import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="0 0 28 28" {...props}>
      <title id="Alpha">{props.title || 'Alpha'}</title>
      <g>
        <path d="M0 14q0-3.3 1.6-6t4.4-4.4 6-1.6 6 1.6 4.4 4.4 1.6 6-1.6 6-4.4 4.4-6 1.6-6-1.6-4.4-4.4-1.6-6zm3.5 0q0 2.3 1.1 4.3t3.1 3.1 4.3 1.1v-17q-2.3 0-4.3 1.1t-3.1 3.1-1.1 4.3z" />
      </g>
    </Icon>
  )
}



// WEBPACK FOOTER //
// ./client/components/icons/alpha.js